import { render, staticRenderFns } from "./skuTab.vue?vue&type=template&id=9ab13c02&"
import script from "./skuTab.vue?vue&type=script&lang=ts&"
export * from "./skuTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports